import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { handleSaveButtonClick as i, getSaveIconName as m, getSavedButtonLabelTranslationKey as n } from "./consts.js";
import { DealSaveButtonMobileContainer as c, DealSaveButtonIcon as u, DealSaveButtonMobileTitle as p } from "./style.js";
import { useTranslation as B } from "../../../hooks/useTranslation/index.js";
function h({
  isSaved: o,
  id: a,
  dispatch: r
}) {
  const { t } = B("common");
  return /* @__PURE__ */ l(
    c,
    {
      "aria-pressed": o,
      onClick: () => i({ isSaved: o, id: a, dispatch: r }),
      children: [
        /* @__PURE__ */ e(
          u,
          {
            icon: m(o),
            "aria-label": t(n(o))
          }
        ),
        /* @__PURE__ */ e(p, { children: t(n(o)) })
      ]
    }
  );
}
export {
  h as DealSaveButtonMobile
};
